import React from 'react'
import withStyles from '@mui/styles/withStyles';

const fieldWidth = 200

const styles = theme => ({
    extraMargin: {
        marginRight: `${fieldWidth}px !important`
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: fieldWidth
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'relative',
        marginTop: theme.spacing(3)
    },
    buttonProgress: {
        color: theme.palette.primary.main
    }
})

const FormWrapper = props => {
    const { form: Form, classes, ...rest } = props
    return (
        <Form formClasses={classes} {...rest} />
    )
}

export default withStyles(styles)(FormWrapper)
